import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEyeOpen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 7C8.72822 7 6.55907 8.27465 4.4606 11C6.55907 13.7254 8.72822 15 11 15C13.2718 15 15.4409 13.7254 17.5394 11C15.4409 8.27465 13.2718 7 11 7ZM11 17C7.68629 17 4.68629 15 2 11C4.68629 7 7.68629 5 11 5C14.3137 5 17.3137 7 20 11C17.3137 15 14.3137 17 11 17ZM11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEyeOpen);

export default ForwardRef;
